import SeoTags from "../../../seo/SeoTags";
import LeftRail from "../left-rail/LeftRail";
import { useLang } from "../../../i18n/LangContext";
import DesktopFaqHero from "./hero/DesktopFaqHero";
import DesktopFooter from "../footer/DesktopFooter";
import GlobeFx from "../../../assets/footer/globe.png";
import GlobeBase from "../../../assets/footer/globe 1.png";
import LogoPNG from "../../../assets/footer/logo-footer.png";
import DesktopFaqTabs from "./faq/DesktopFaqTabs";
import ContactFormGlass from "../../common/contact/ContactFormGlass";
import "../desktopAppMonetize/DesktopAppRegisterPublisher.css";

export default function DesktopAppFaq({ onGetStarted = () => { }, onContact = () => { } }) {
  const { lang, t } = useLang();
  const isBG = lang === "bg";

  const base = "https://offerwall-web-9dd25471534d.herokuapp.com";
  const url = `${base}/faq`;
  const canonical = url;
  const locale = isBG ? "bg_BG" : "en_US";

  const title = isBG ? "Givvy Offerwall — Често задавани въпроси" : "Givvy Offerwall — Frequently Asked Questions";
  const description = isBG
    ? "Всичко за нашия премиум offerwall — реклами, монетизация, поддръжка."
    : "Everything you need to know about our premium offerwall: advertising, monetization, and support.";

  const sections = [
    { id: "faq-hero", label: t.nav.faq },
    { id: "faq-tabs", label: t.faqTabs?.[0]?.label || "FAQ" },
  ];

  return (
    <>
      <SeoTags
        title={title}
        description={description}
        url={url}
        canonical={canonical}
        locale={locale}
        alternates={[{ href: url, hreflang: "x-default" }]}
        image={`${base}/og/og-hero.jpg`}
      />

      <LeftRail
        sections={sections}
        railLeft={100}
        navHeight={88}
        dotSize={16}
        dotsSide="left"
        dotsGap={54}
        dotsVAlign="center"
      />

      <div className="desktop-monetize-area">
        <DesktopFaqHero id="faq-hero" onGetStarted={onGetStarted} onContact={onContact} />

        <DesktopFaqTabs id="faq-tabs" />

        <ContactFormGlass
          id="contact"
          eyebrow={t.contactForm.eyebrow}
          titleLine1={t.contactForm.titleLine1}
          titleLine2={t.contactForm.titleLine2}
          fields={t.contactForm.fields}
          roleOptions={t.contactForm.roleOptions}
          submitLabel={t.contactForm.submit}
        />

        <DesktopFooter
          logoSrc={LogoPNG}
          globeSrc={GlobeBase}
          globeOverlaySrc={GlobeFx}
          socialLinks={[
            "https://facebook.com/…",
            "https://instagram.com/…",
            "https://youtube.com/…",
            "https://t.me/…",
            "https://x.com/…",
            "https://tiktok.com/@…",
          ]}
        />
      </div>
    </>
  );
}
